import { CodeConductPage } from "../../../sections/@code-conduct/CodeConductPage";

export const CodeConductPageWrapper = () => (
  <CodeConductPage/>
);
